import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/resource/global.css'
import '@/utils/responsive.css'
import "@/utils/initialize"
import './resource/icon_store/iconfont.css'
import ElementUI from 'element-ui';
import request from './utils/request';
import 'element-ui/lib/theme-chalk/index.css';
import './resource/font3/iconfont.css'
import { updateMetaTags } from './utils/meta'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.request=request;

// 路由导航守卫，用于更新meta标签
router.beforeEach((to, from, next) => {
  // 更新页面meta信息
  if (to.meta) {
    updateMetaTags(to.meta);
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
